import { Link, useNavigate } from "react-router-dom";
import Logo from "@/components/Logo";
import { useAuth } from "@/lib/auth";
import { C } from "@/lib/brand";

export default function PublicNav({ variant = "dark" }) {
  const navigate = useNavigate();
  const { consumer } = useAuth();
  const isAuthed = !!consumer;
  const isDark = variant === "dark";
  const bg = isDark ? C.ink : C.cream;
  const fg = isDark ? C.cream : C.ink;
  const muted = isDark ? "rgba(250,246,240,0.7)" : C.warmGray;

  return (
    <nav
      data-testid="public-nav"
      data-authed={isAuthed ? "true" : "false"}
      style={{
        background: bg,
        borderBottom: `1px solid ${isDark ? "rgba(255,255,255,0.08)" : C.warmGray4}`,
        position: "sticky",
        top: 0,
        zIndex: 40,
      }}
    >
      <div
        style={{
          width: "100%",
          padding: "18px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Link to="/" data-testid="nav-logo-link">
          <Logo light={isDark} size={22} />
        </Link>
        <div style={{ display: "flex", alignItems: "center", gap: 28 }}>
          <Link
            to="/catalogue"
            data-testid="nav-catalogue-link"
            style={{ fontSize: 11, fontWeight: 800, letterSpacing: "0.18em", color: fg, textDecoration: "none" }}
            className="hidden md:inline"
          >
            CATALOGUE
          </Link>
          <Link
            to="/for-employers"
            data-testid="nav-for-employers-link"
            style={{ fontSize: 11, fontWeight: 800, letterSpacing: "0.18em", color: muted, textDecoration: "none" }}
            className="hidden md:inline"
          >
            FOR EMPLOYERS
          </Link>
          <Link
            to="/for-employers#how"
            data-testid="nav-how-link"
            style={{ fontSize: 11, fontWeight: 800, letterSpacing: "0.18em", color: muted, textDecoration: "none" }}
            className="hidden lg:inline"
          >
            HOW IT WORKS
          </Link>
          {isAuthed ? (
            <>
              <span
                data-testid="nav-signed-in-name"
                style={{ fontSize: 11, fontWeight: 800, letterSpacing: "0.18em", color: muted, textTransform: "uppercase" }}
                className="hidden md:inline"
              >
                {(consumer.firstName || "Member").toUpperCase()}
              </span>
              <button
                data-testid="nav-go-to-app-btn"
                onClick={() => navigate("/app")}
                style={{
                  padding: "10px 18px",
                  background: C.peach,
                  color: C.ink,
                  fontSize: 11,
                  fontWeight: 800,
                  letterSpacing: "0.18em",
                  border: 0,
                  cursor: "pointer",
                }}
              >
                GO TO APP →
              </button>
            </>
          ) : (
            <>
              <Link
                to="/sign-in"
                data-testid="nav-signin-link"
                style={{ fontSize: 11, fontWeight: 800, letterSpacing: "0.18em", color: fg, textDecoration: "none" }}
              >
                SIGN IN
              </Link>
              <button
                data-testid="nav-getaccess-btn"
                onClick={() => navigate("/get-access")}
                style={{
                  padding: "10px 18px",
                  background: C.peach,
                  color: C.ink,
                  fontSize: 11,
                  fontWeight: 800,
                  letterSpacing: "0.18em",
                  border: 0,
                  cursor: "pointer",
                }}
              >
                GET ACCESS →
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
